export interface SelectOption {
  id: string | number;
  name: string;
}
